import React from 'react';
import Title from '../shared/Title';

const MeetTeamContainer = () => {
    return (
        <>
            <Title text1="Meet the" text2="Team" colorForText={2} isLight={true} />
            <p className='text-xl text-white-50 font-light'>Get to know the talented professionals who drive our success. Each member brings unique expertise and passion, working together to deliver exceptional results for our clients</p>
        </>
    );
};

export default MeetTeamContainer;